export default __webpack_public_path__ + "static/media/hinh-nho-2.6cc22f1e.png";